@if (inited) {
    <div class="flex-col height100p">
        <sm-toolbar class="flex-item-fixed">
            <p-button icon="fas fa-plus" label="Neu" (onClick)="addFieldTrip()">
            </p-button>
        </sm-toolbar>
        <sm-table class="flex-item-fill" [data]="table" (onCellClicked)="fieldTripClicked($event)"></sm-table>
    </div>
}